import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import 'react-phone-number-input/style.css';
import circleError from '../../assets/images/circle-exclamation-error.svg';
import './Cubicaje.css';
import { UnidadMedidaM, UnidadMedidaPeso } from './DataOptions';
import CustomMessage from '../../core/CustomMessage/CustomMessage';
import { IFormData, Pallet } from './Cubicaje';
import CustomToolTip from '../../core/CustomToolTip/CustomToolTip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useForm } from 'react-hook-form';
import { numeric } from 'yup-numeric';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { faArrowRight, faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import europallet360carga from '../../assets/videos/cubicaje/europallet360carga.gif';
import standardPalet360Cargado from '../../assets/videos/cubicaje/Standard-pallet-360-cargado.gif';
import europalet360desaprovechado from '../../assets/videos/cubicaje/euro-pallet-desaprovechado.gif';
import standardpalet360desaprovechado from '../../assets/videos/cubicaje/standard-pallet-desaprovechado.gif';
import { formatNumber, numberDotRegex, validateNumberRegex } from '../../utils/helpers';

interface Props {
	palletItem: Pallet;
	handleSecondStep: (status: boolean) => void;
	handleContinueClick: () => void;
	areErrors: React.MutableRefObject<boolean>;
	formData: IFormData;
	setFormData: Function;
	onCubicajeSelected: Function;
	setIsLegalModalVisible: Function;
}

interface Map {
	[key: string]: number;
}
const CubicajeSeccionDos: React.FC<Props> = ({
	palletItem,
	handleSecondStep,
	handleContinueClick,
	formData,
	setFormData,
	areErrors,
	onCubicajeSelected,
	setIsLegalModalVisible,
}) => {
	const { t } = useTranslation();
	var convert = require('convert-units');
	const [showMessageLargo, setShowMessageLargo] = useState(false);
	const [showMessageAncho, setShowMessageAncho] = useState(false);
	const [showMessageYellowLargo, setShowMessageYellowLargo] = useState(false);
	const [showMessageYellowAncho, setShowMessageYellowAncho] = useState(false);
	const [showMessageAprovechamiento, setShowMessageAprovechamiento] = useState(false);
	const [showMessageWeight, setShowMessageWeight] = useState<boolean>(false);
	const [ShowMessageYellowAprov, setShowMessageYellowAprov] = useState(false);
	const [showMessageValidator, setShowMessageValidator] = useState(false);
	const [alto, setAlto] = useState<any | null>();
	const [largo, setLargo] = useState<any | null>();
	const [ancho, setAncho] = useState<any | null>();
	const [aprovCalc, setAprovCalc] = useState<number>();
	const [peso, setPeso] = useState<any>();
	const [unidadMedidaDistancia, setUnidadMedidaDistancia] = useState(palletItem.unidadMedida);
	const [unidadMedidaPesoSelected, setunidadMedidaPesoSelected] = useState(palletItem.unidadPeso);
	const [showMessageDesaprovechamiento, setShowMessageDesaprovechamiento] = useState(false);
	const [isBridgeError, setIsBridgeError] = useState(false);
	const [isLargeError, setIsLargeError] = useState(false);
	const [isTallError, setIsTallError] = useState(false);
	const [isWeightError, setIsWeightError] = useState(false);
	const [areShowErrorsVisible, setAreErrorsVisible] = useState<boolean>(false);
	const [showMessageErrorAprovechamiento, setShowMessageErrorAprovechamiento] = useState<boolean>(false);
	const [showMessageRedAprov, setShowMessageRedAprov] = useState<boolean>(false);

	const largoConvertRef = useRef<number>(0);
	const anchoConvertRef = useRef<number>(0);
	const superficieCajaRef = useRef<number>(0);
	const superficiePalletRef = useRef<number>(0);
	const aprovechamientoRef = useRef<number>(0);

	const titlePallet = palletItem.index;

	const pesoStep21: Map = {
		mg: 100000000,
		g: 1000000,
		kg: 1000,
		libra: 453592,
		onza: 28349.5,
	};

	// Valores máximos en kg para cada unidad de peso
	const pesoMaximoEnKg: Map = {
		mg: 100000000 / 1000000, // 100 kg en mg convertido a kg
		g: 1000000 / 1000, // 1000 kg en g convertido a kg
		kg: 1000, // 1000 kg
		libra: 453592 / 1000, // 453.592 kg en libras convertido a kg
		onza: 28349.5 / 1000, // 28.3495 kg en onzas convertido a kg
	};

	const medidasStep2 = [
		{
			id: 0,
			title: t('cubicaje.step_1.europalet.title'),
			medidas: [
				{
					unidadMedida: 'mm',
					ancho: 800,
					largo: 1200,
					alto: 2135,
				},
				{
					unidadMedida: 'cm',
					ancho: 80,
					largo: 120,
					alto: 213.5,
				},
				{
					unidadMedida: 'ft',
					ancho: 2.62467,
					largo: 3.937,
					alto: 7,
				},
				{
					unidadMedida: 'in',
					ancho: 31.496,
					largo: 47.244,
					alto: 84.05,
				},
			],
		},
		{
			id: 1,
			title: t('cubicaje.step_1.americano.title'),
			medidas: [
				{
					unidadMedida: 'mm',
					ancho: 1000,
					largo: 1200,
					alto: 2135,
				},
				{
					unidadMedida: 'cm',
					ancho: 100,
					largo: 120,
					alto: 213.5,
				},
				{
					unidadMedida: 'ft',
					ancho: 3.2808,
					largo: 3.937,
					alto: 7,
				},
				{
					unidadMedida: 'in',
					ancho: 39.37,
					largo: 47.244,
					alto: 84.05,
				},
			],
		},
	];

	const medidasTitlePallet = medidasStep2.filter(({ id }) => id === titlePallet);
	const unidadMedida = medidasTitlePallet[0]?.medidas?.filter(
		({ unidadMedida }) => unidadMedida === unidadMedidaDistancia,
	);
	const schema = yup.object().shape({
		altos: numeric()
			.min(1, 'Min value 1')
			.required()
			.typeError(t('cubicaje.step_2.required'))
			.max(unidadMedida[0].alto, `max ${unidadMedida[0]?.alto}`),
		anchos: numeric()
			.min(1, 'Min value 1')
			.required()
			.typeError(t('cubicaje.step_2.required'))
			.max(unidadMedida[0].ancho, `max ${unidadMedida[0].ancho}`),
		largos: numeric()
			.min(1, 'Min value 1')
			.required()
			.typeError(t('cubicaje.step_2.required'))
			.max(unidadMedida[0].largo, `max ${unidadMedida[0].largo}`),
		pesos: numeric()
			.min(0, 'Min value 0')
			.required()
			.typeError(t('cubicaje.step_2.required'))
			.max(pesoMaximoEnKg[unidadMedidaPesoSelected], `max ${pesoMaximoEnKg[unidadMedidaPesoSelected]} kg`),
	});

	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm({
		resolver: yupResolver(schema),
	});

	// Función auxiliar para convertir cualquier unidad a mm
	function convertToMm(value: number, fromUnit: string): number {
		if (fromUnit === 'mm') {
			return value;
		} else if (fromUnit === 'cm') {
			return value * 10;
		} else if (fromUnit === 'ft') {
			return value * 304.8;
		} else if (fromUnit === 'in') {
			return value * 25.4;
		}
		return value; // fallback
	}

	// Función auxiliar para convertir cualquier unidad de peso a kg
	function convertToKg(value: number, fromUnit: string): number {
		if (fromUnit === 'kg') {
			return value;
		} else if (fromUnit === 'g') {
			return value / 1000;
		} else if (fromUnit === 'mg') {
			return value / 1000000;
		} else if (fromUnit === 'libra') {
			return value * 0.453592;
		} else if (fromUnit === 'onza') {
			return value * 0.0283495;
		}
		return value; // fallback
	}

	const onSubmit = (data: any) => {
		// Verificar que los valores existan antes de convertir
		if (!formData.largoStep2 || !formData.anchoStep2 || !formData.altoStep2 || !formData.pesoStep2) {
			console.error('Faltan valores requeridos');
			return;
		}

		// Debug: mostrar valores originales
		console.log('=== DEBUG formData ANTES de conversión ===');
		console.log('formData original:', {
			largoStep2: formData.largoStep2,
			anchoStep2: formData.anchoStep2,
			altoStep2: formData.altoStep2,
			pesoStep2: formData.pesoStep2,
			unidadMedida: unidadMedidaDistancia,
			unidadPeso: unidadMedidaPesoSelected,
		});

		// Detectar si los valores ya están en mm (si son muy grandes para ser cm)
		const largoOriginal = parseFloat(formData.largoStep2);
		const anchoOriginal = parseFloat(formData.anchoStep2);
		const altoOriginal = parseFloat(formData.altoStep2);
		const pesoOriginal = parseFloat(formData.pesoStep2);

		// Verificar si los valores ya están en mm basándose en la unidad de medida
		// Si la unidad es 'mm', no convertir. Si es otra unidad, convertir.
		const yaEstanEnMm = unidadMedidaDistancia === 'mm';

		// Verificar si el peso ya está en kg
		const yaEstaEnKg = unidadMedidaPesoSelected === 'kg';

		// Verificar si ya se han mostrado mensajes de aprovechamiento para evitar conversión doble
		const yaSeMostraronMensajes = showMessageDesaprovechamiento || showMessageAprovechamiento;

		let largoEnMm: number, anchoEnMm: number, altoEnMm: number, pesoEnKg: number;

		if (yaEstanEnMm || yaSeMostraronMensajes) {
			// Los valores ya están en mm o ya se procesaron, no convertir
			largoEnMm = largoOriginal;
			anchoEnMm = anchoOriginal;
			altoEnMm = altoOriginal;
			console.log('Valores ya están en mm o ya se procesaron, no se convierten');
		} else {
			// Convertir de la unidad original a mm
			largoEnMm = convertToMm(largoOriginal, unidadMedidaDistancia);
			anchoEnMm = convertToMm(anchoOriginal, unidadMedidaDistancia);
			altoEnMm = convertToMm(altoOriginal, unidadMedidaDistancia);
		}

		// Convertir peso a kg
		if (yaEstaEnKg || yaSeMostraronMensajes) {
			pesoEnKg = pesoOriginal;
			console.log('Peso ya está en kg o ya se procesó, no se convierte');
		} else {
			pesoEnKg = convertToKg(pesoOriginal, unidadMedidaPesoSelected);
		}

		// Debug: mostrar valores convertidos
		console.log('=== DEBUG valores convertidos ===');
		console.log('Valores en mm:', {
			largoEnMm,
			anchoEnMm,
			altoEnMm,
		});
		console.log('Peso en kg:', pesoEnKg);

		// Verificar que las conversiones sean válidas
		if (isNaN(largoEnMm) || isNaN(anchoEnMm) || isNaN(altoEnMm) || isNaN(pesoEnKg)) {
			console.error('Error en la conversión de unidades');
			return;
		}

		setFormData({
			...formData,
			largoStep2: largoEnMm,
			anchoStep2: anchoEnMm,
			altoStep2: altoEnMm,
			pesoStep2: pesoEnKg,
			unidadMedidaStep2: unidadMedidaDistancia,
			unidadPesoStep2: unidadMedidaPesoSelected,
		});

		// Usar los valores convertidos directamente para los cálculos
		hanldeCalcLargo(largoEnMm);
		hanldeCalcAncho(anchoEnMm);
		hanldeCalcMedidas();
		verificarSiEjecutaAprov();

		// Solo continuar si no hay errores críticos
		if (!areErrors.current) {
			handleSecondStep(true);
			handleContinueClick();
		} else {
			// Si hay errores, solo actualizar el estado pero no continuar
			console.log('Hay errores de validación, no se puede continuar');
		}
	};

	function hanldeCalcMedidas() {
		SuperficieOcupanCajas();
		SuperficiePalet();

		const aprovPercent = Aprovechamiento();
		if (aprovPercent < 100 && aprovPercent > palletItem.aprov) {
			setShowMessageDesaprovechamiento(true);
			onCubicajeSelected(false, palletItem.index === 0 ? europalet360desaprovechado : standardpalet360desaprovechado);
		} else {
			setShowMessageDesaprovechamiento(false);
		}
	}

	function handleMeidaDis(value: string) {
		setUnidadMedidaDistancia(value);
	}

	function handleMeidaPeso(value: string) {
		setunidadMedidaPesoSelected(value);
	}

	//Calcular Largo con la unidad de medida del Pallet vs Seleccionado
	function hanldeCalcLargo(unidadIngresada: number) {
		let valor1 = unidadIngresada;
		if (isNaN(unidadIngresada)) {
			setShowMessageYellowLargo(false);
			setShowMessageLargo(false);
			areErrors.current = true;
			return;
		} else {
			// Ahora trabajamos con valores ya convertidos a mm
			// Convertir el valor de entrada a la unidad del pallet si es necesario
			if (palletItem.unidadMedida === 'mm') {
				valor1 = unidadIngresada;
			} else {
				try {
					valor1 = convert(unidadIngresada).from('mm').to(palletItem.unidadMedida);
				} catch (error) {
					console.error('Error en conversión de largo:', error);
					areErrors.current = true;
					return;
				}
			}
			largoConvertRef.current = valor1;

			//Validar Valores despues de conversion.
			if (valor1 !== undefined && valor1 > palletItem.largo) {
				setShowMessageYellowLargo((status) => (status = true));
				setShowMessageLargo((status) => (status = true));
				handleSecondStep(false);
				setAreErrorsVisible(true);
				areErrors.current = true;
			} else {
				setShowMessageYellowLargo(false);
				setShowMessageLargo(false);
				handleSecondStep(true);
			}
		}
	}

	//Calcular Ancho con la unidad de medida del Pallet
	function hanldeCalcAncho(unidadIngresada: number) {
		let valorAncho = unidadIngresada;
		if (isNaN(unidadIngresada)) {
			setShowMessageYellowAncho(false);
			setShowMessageAncho(false);
			areErrors.current = true;
			return;
		} else {
			// Ahora trabajamos con valores ya convertidos a mm
			// Convertir el valor de entrada a la unidad del pallet si es necesario
			if (palletItem.unidadMedida === 'mm') {
				valorAncho = unidadIngresada;
			} else {
				try {
					valorAncho = convert(unidadIngresada).from('mm').to(palletItem.unidadMedida);
				} catch (error) {
					console.error('Error en conversión de ancho:', error);
					areErrors.current = true;
					return;
				}
			}
			anchoConvertRef.current = valorAncho;

			//Validar Valores despues de conversion.
			if (valorAncho !== undefined && valorAncho > palletItem.ancho) {
				setShowMessageYellowAncho((status) => (status = true));
				setShowMessageAncho((status) => (status = true));
				handleSecondStep(false);
				setAreErrorsVisible(true);
				areErrors.current = true;
			} else {
				setShowMessageYellowAncho(false);
				setShowMessageAncho(false);
				handleSecondStep(true);
			}
		}
	}

	function verificarSiEjecutaAprov() {
		if (
			largoConvertRef.current !== undefined &&
			largoConvertRef.current > 0 &&
			anchoConvertRef.current !== undefined &&
			anchoConvertRef.current > 0
		) {
			const aprovechamiento = aprovechamientoRef.current;
			setAprovCalc(aprovechamiento);

			if (aprovechamiento > 100) {
				setShowMessageErrorAprovechamiento(true);
				setShowMessageAprovechamiento(false);
				setShowMessageRedAprov(true);
				areErrors.current = true;
			} else if (aprovechamiento < palletItem.aprov) {
				setShowMessageYellowAprov(false);
				setShowMessageAprovechamiento(true);
				onCubicajeSelected(false, palletItem.index === 0 ? europallet360carga : standardPalet360Cargado);
				setShowMessageErrorAprovechamiento(false);
				areErrors.current = true;
			} else {
				setShowMessageYellowAprov(true);
				setShowMessageAprovechamiento(true);
				onCubicajeSelected(false, palletItem.index === 0 ? europallet360carga : standardPalet360Cargado);
				setShowMessageErrorAprovechamiento(false);
				areErrors.current = false;
			}
			setAreErrorsVisible(true);
		}
	}

	//calculo Cantidad de cajas por ancho =parte entera de ( [ancho del palet] / [ancho de la caja])
	function CantidadCajasxAncho() {
		const anchoPallet = palletItem.ancho;
		const anchoCaja = anchoConvertRef.current;

		return Math.trunc(anchoPallet / anchoCaja).toFixed(0);
	}

	//Cantidad de cajas por largo =parte entera de ( [largo del palet] / [largo de la caja]) Ejemplo: 800/230 = 3.4782; resultado = 3
	function CantidadCajasxLargo() {
		const largoPallet = palletItem.largo;
		const largoCaja = largoConvertRef.current;
		return Math.trunc(largoPallet / largoCaja).toFixed(0);
	}

	//(kCajasAncho x [ancho de la caja] x (kCajasLargo x [largo de la caja] Ejemplo: (2 x 555) x (3x230) = 765900
	function SuperficieOcupanCajas() {
		const cajasXAncho = parseFloat(CantidadCajasxAncho());
		const anchoCaja = anchoConvertRef.current;
		const cajasXLargo = parseFloat(CantidadCajasxLargo());
		const largoCaja = largoConvertRef.current;
		const superficieCaja = cajasXAncho * anchoCaja * (cajasXLargo * largoCaja);
		superficieCajaRef.current = superficieCaja;

		return superficieCaja;
	}

	//[Superficie del palet] = [ancho del palet] x [largo del palet] Ejemplo: 1200 x 800 = 960000
	function SuperficiePalet() {
		const anchoPallet = palletItem.ancho;
		const largoPallet = palletItem.largo;
		const superficiePallet = anchoPallet * largoPallet;
		superficiePalletRef.current = superficiePallet;

		return superficiePallet;
	}

	//Calculo para el Aprovechamiento Aprovechamiento: ([Superficie que ocupan las cajas] / [Superficie del palet] * 100
	function Aprovechamiento() {
		var superficieCaja = superficieCajaRef.current;
		var superficiePallet = superficiePalletRef.current;
		const aprovechamiento = parseFloat(((superficieCaja / superficiePallet) * 100).toFixed(2));
		aprovechamientoRef.current = aprovechamiento;

		return aprovechamiento;
	}

	//Calcular el desperdicio test
	function CalcularDesperdicio() {
		var aprovechamiento = aprovechamientoRef.current;

		return (100 - aprovechamiento).toFixed(2);
	}

	// const onValidateForm = () => {
	//   const isErrorAlto = !alto || alto === null || isNaN(alto);
	//   const isErrorAncho = !ancho || ancho === null || isNaN(ancho);
	//   const isErrorLargo = !largo || largo === null || isNaN(largo);
	//   const isErrorPeso = !peso || peso === null || isNaN(peso);
	//   const isErrorPesoPermitido =
	//     !peso || peso > formData.palletData.allowedWeight;

	//   setIsTallError(isErrorAlto);
	//   areErrors.current = isErrorAlto;
	//   setAreErrorsVisible(isErrorAlto);

	//   setIsBridgeError(isErrorAncho);
	//   areErrors.current = isErrorAncho;
	//   setAreErrorsVisible(isErrorAncho);

	//   setIsLargeError(isErrorLargo);
	//   areErrors.current = isErrorLargo;
	//   setAreErrorsVisible(isErrorLargo);

	//   setIsWeightError(isErrorPeso);
	//   areErrors.current = isErrorPeso;
	//   setAreErrorsVisible(isErrorPeso);

	//   areErrors.current = isErrorPesoPermitido;
	//   setAreErrorsVisible(isErrorPesoPermitido);
	//   setShowMessageWeight(isErrorPesoPermitido);

	//   if (peso && largo && alto && ancho && !areErrors.current) {
	//     hanldeCalcLargo(parseFloat(formData.largoStep2));
	//     hanldeCalcAncho(parseFloat(formData.anchoStep2));
	//     hanldeCalcMedidas();
	//     verificarSiEjecutaAprov();
	//     handleContinueClick();
	//   }
	// };

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}, []);

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<div className="cubicaje_title-step_2 ">
				{t('cubicaje.step_2.subtitle')}{' '}
				<CustomToolTip
					title=""
					tooltipText={t('cubicaje.step_2.subtitle.tooltip')}>
					<FontAwesomeIcon
						icon={faCircleQuestion}
						className="font-size: 15px"
					/>
				</CustomToolTip>
			</div>
			{showMessageLargo && areShowErrorsVisible && (
				<CustomMessage
					background={`${showMessageYellowLargo ? '#F4B400' : '#2ECADF'}`}
					textMessage={t('cubicaje.step_2.message_1')}
				/>
			)}

			{showMessageAncho && areShowErrorsVisible && (
				<CustomMessage
					background={`${showMessageYellowAncho ? '#F4B400' : '#2ECADF'}`}
					textMessage={t('cubicaje.step_2.message_2')}
				/>
			)}
			{areShowErrorsVisible &&
				(parseFloat(CalcularDesperdicio()) > 10
					? showMessageDesaprovechamiento && (
							<CustomMessage
								background={`#F4B400`}
								textMessage={`${t('cubicaje.step_2.message_3a')} ${CalcularDesperdicio()}% ${t('cubicaje.step_2.message_3b')}.`}
							/>
						)
					: showMessageAprovechamiento && (
							<CustomMessage
								background={`${ShowMessageYellowAprov ? '#F4B400' : '#2ECADF'}`}
								textMessage={`${t('cubicaje.step_2.message_4a')} ${aprovCalc}% ${t('cubicaje.step_2.message_3b')}.`}
							/>
						))}

			{showMessageErrorAprovechamiento && areShowErrorsVisible && (
				<CustomMessage
					background={`${showMessageRedAprov ? 'red' : '#2ECADF'}`}
					textMessage={`${t('cubicaje.step_2.message_5')} ${aprovCalc}%.`}
				/>
			)}

			{showMessageValidator && areShowErrorsVisible && (
				<CustomMessage
					background={`#F4B400`}
					textMessage={t('cubicaje.step_2.message_6')}
				/>
			)}

			{showMessageWeight && areShowErrorsVisible && (
				<CustomMessage
					background={`#F4B400`}
					textMessage={`${t('cubicaje.step_2.message_7')} ${formData.palletData.allowedWeight}${formData.palletData.unidadPeso}.`}
				/>
			)}

			<div className="rowcubicaje-container">
				<div className="rowcubicaje-col rowcubicaje-min">
					<div className="CustomizedSelect__container">
						<div className="CustomizedSelect__title">{t('cubicaje.step_2.unit')}</div>
						<div className="country-info">
							<select
								style={{ maxWidth: 65 }}
								defaultValue={unidadMedidaDistancia}
								onChange={(e) => {
									handleMeidaDis(e.currentTarget.value);
								}}>
								{UnidadMedidaM.map((option, index) => (
									<option
										key={index}
										value={option}>
										{option}
									</option>
								))}
							</select>
						</div>
					</div>
				</div>
				<div className="rowcubicaje-col rowcubicaje-half">
					<div className="shortInput container-label">
						<input
							{...register('anchos')}
							type="text"
							className="inputItem"
							value={ancho || ''}
							onChange={(e) => {
								e.preventDefault();
								setAreErrorsVisible(false);
								const anchoStep2 = e.currentTarget.value;

								if (numberDotRegex.test(anchoStep2)) {
									const formatAncho = formatNumber(anchoStep2);
									setAncho(formatAncho);
									setFormData((prevData: IFormData) => ({
										...prevData,
										anchoStep2: formatAncho,
									}));
									if (alto !== null && ancho !== null && largo !== null && alto !== 0 && ancho !== 0 && largo !== 0) {
										setShowMessageValidator(false);
									}
									setIsBridgeError(false);
								}
							}}
						/>
						<label className="form-label">{t('cubicaje.step_2.width.placeholder')}</label>
						{isBridgeError && (
							<div className="container errorContainer">
								<img
									src={circleError}
									alt="error-icon"
								/>
								<p className="errorInputValidation">{t('cubicaje.step_2.required')}</p>
							</div>
						)}
						{errors.anchos && (
							<div className="container errorContainer">
								<img
									src={circleError}
									alt="error-icon"
								/>
								<p className="errorInputValidation">{errors.anchos?.message}</p>
							</div>
						)}
					</div>
				</div>
				<div className="rowcubicaje-col rowcubicaje-min rowcubicaje-rightmin shortInput">
					<div className="shortInputDiv container-label">
						<input
							{...register('largos')}
							type="text"
							className="inputItem shortInput"
							value={largo || ''}
							onChange={(e) => {
								e.preventDefault();
								setAreErrorsVisible(false);
								const largoStep2 = e.currentTarget.value;

								if (numberDotRegex.test(largoStep2)) {
									const formatLargo = formatNumber(largoStep2);
									setLargo(formatLargo);
									setFormData((prevData: IFormData) => ({
										...prevData,
										largoStep2: formatLargo,
									}));

									if (
										alto !== null &&
										ancho !== null &&
										parseFloat(largoStep2) !== null &&
										alto !== 0 &&
										ancho !== 0 &&
										parseFloat(largoStep2) !== 0
									) {
										setShowMessageValidator(false);
									}
									setIsLargeError(false);
								}
							}}
						/>
						<label className="form-label">{t('cubicaje.step_2.long.placeholder')}</label>
						{errors.largos && (
							<div className="container errorContainer">
								<img
									src={circleError}
									alt="error-icon"
								/>
								<p className="errorInputValidation">{errors.largos?.message}</p>
							</div>
						)}
						{isLargeError && (
							<div className="container errorContainer">
								<img
									src={circleError}
									alt="error-icon"
								/>
								<p className="errorInputValidation">{t('cubicaje.step_2.required')}</p>
							</div>
						)}
					</div>
				</div>

				<div className="rowcubicaje-col rowcubicaje-half">
					<div className="shortInput container-label">
						<input
							{...register('altos')}
							type="text"
							className="inputItem shortInput "
							value={alto || ''}
							onChange={(e) => {
								e.preventDefault();

								setAreErrorsVisible(false);
								const altoStep2 = e.currentTarget.value;

								if (numberDotRegex.test(altoStep2)) {
									const formatAlto = formatNumber(altoStep2);
									setAlto(formatAlto);
									setFormData((prevData: IFormData) => ({
										...prevData,
										altoStep2: formatAlto,
									}));
									if (alto !== null && ancho !== null && largo !== null && alto !== 0 && ancho !== 0 && largo !== 0) {
										setShowMessageValidator(false);
									}
									setIsTallError(false);
								}
							}}
						/>
						<label className="form-label">{t('cubicaje.step_2.height.placeholder')}</label>
						{errors.altos && (
							<div className="container errorContainer">
								<img
									src={circleError}
									alt="error-icon"
								/>
								<p className="errorInputValidation">{errors.altos?.message}</p>
							</div>
						)}
						{isTallError && (
							<div className="container errorContainer">
								<img
									src={circleError}
									alt="error-icon"
								/>
								<p className="errorInputValidation">{t('cubicaje.step_2.required')}</p>
							</div>
						)}
					</div>
				</div>
			</div>
			<div className="rowcubicaje-container rowcubicaje-container--doble">
				<div className="rowcubicaje-col">
					<div className="CustomizedSelect__container">
						<div className="CustomizedSelect__title">{t('cubicaje.step_2.unit')}</div>
						<div className="country-info">
							<select
								style={{ maxWidth: 65 }}
								defaultValue={unidadMedidaPesoSelected}
								onChange={(e) => {
									const nuevaUnidadPeso = e.currentTarget.value;
									handleMeidaPeso(nuevaUnidadPeso);
									// No sobrescribir pesoStep2 aquí, solo actualizar la unidad
								}}>
								{UnidadMedidaPeso.map((option, index) => (
									<option
										key={index}
										value={option}>
										{option}
									</option>
								))}
							</select>
						</div>
					</div>
				</div>
				<div className="rowcubicaje-col col-11 weightContainer">
					<div className="inputContainer container-label">
						<input
							{...register('pesos')}
							type="text"
							className="inputItemWeight"
							value={peso || ''}
							onChange={(e) => {
								e.preventDefault();
								setAreErrorsVisible(false);
								const pesoStep2 = e.currentTarget.value;

								if (numberDotRegex.test(pesoStep2)) {
									const formatPeso = formatNumber(pesoStep2);
									setPeso(formatPeso);
									setFormData((prevData: IFormData) => ({
										...prevData,
										pesoStep2: formatPeso,
									}));
									setIsWeightError(false);
								}
							}}
						/>
						<label className="form-label">{t('cubicaje.step_2.weight.placeholder')}</label>
						{errors.pesos && (
							<div className="container errorContainer">
								<img
									src={circleError}
									alt="error-icon"
								/>
								<p className="errorInputValidation">{errors.pesos?.message}</p>
							</div>
						)}
						{isWeightError && (
							<div className="container errorContainer">
								<img
									src={circleError}
									alt="error-icon"
								/>
								<p className="errorInputValidation">{t('cubicaje.step_2.required')}</p>
							</div>
						)}
					</div>
				</div>
			</div>
			<div className="mainContainerFooter">
				<div
					className="see_legals"
					onClick={() => setIsLegalModalVisible(true)}>
					<p>{t('cubicaje.legal')}</p>
				</div>
				<button
					type="submit"
					className="cubicaje-information__next">
					<div className="btn-test-next-text">{t('cubicaje.button')}</div>
					<FontAwesomeIcon
						icon={faArrowRight}
						color="black"
					/>
				</button>
			</div>
		</form>
	);
};

export default CubicajeSeccionDos;
